import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./Audit.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>
                        IRS Audit <span>Representation</span>
                    </h3>
                </header>

                <div
                    className={AboutClasses["section-1"]}
                    style={{ gap: "0.5rem", gridTemplateColumns: "0.6fr 1fr" }}>
                    <img src={Image1} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.5rem" }}>
                        <h3>
                            Facing an IRS audit can be a stressful and
                            intimidating experience.
                        </h3>
                        <p>
                            At <b>Serene Tax</b>, we are here to provide expert
                            IRS audit representation, ensuring that your rights
                            are protected and that the audit process is handled
                            efficiently and effectively.
                        </p>
                        <h2>1. Experienced Tax Professionals</h2>
                        <p>
                            {" "}
                            Our team of certified tax professionals has
                            extensive experience handling IRS audits for
                            individuals, businesses, and corporations. We
                            understand the ins and outs of IRS procedures and
                            tax laws, which allows us to represent you with
                            confidence and precision.
                        </p>
                        <h2>2. We Handle Everything for You</h2>
                        <p>
                            {" "}
                            When you work with us, you don't have to worry about
                            direct interactions with the IRS. We handle all
                            communication and paperwork, ensuring that every
                            step of the audit process is managed effectively.
                            Our team will keep you informed and take the stress
                            out of dealing with the IRS.
                        </p>
                        <h2>3. Personalized Strategy</h2>
                        <p>
                            No two audits are the same. That’s why we tailor our
                            approach to meet the unique needs of each client. We
                            analyze your case thoroughly, identify potential
                            issues, and develop a strategy to achieve the best
                            possible outcome.
                        </p>
                        <h2>4. We Protect Your Rights</h2>
                        <p>
                            {" "}
                            IRS audits can be invasive, but with Serene Tax on
                            your side, you can rest assured knowing your rights
                            are protected. We will ensure that the IRS follows
                            proper protocols and that you're treated fairly
                            throughout the entire process.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.5rem" }}>
                        <h3>How We Can Help During an IRS Audit .</h3>
                        <ul>
                            <li>
                                Audit Notification: We’ll help you understand
                                the audit notice and guide you on the next
                                steps.
                            </li>
                            <li>
                                Documentation Collection: Our team will assist
                                in gathering and organizing the necessary
                                documentation to support your case.
                            </li>
                            <li>
                                Audit Representation: We act as your
                                representative during the audit, handling all
                                communication and correspondence with the IRS on
                                your behalf.
                            </li>
                            <li>
                                Negotiation and Settlement: If additional tax is
                                owed, we will work with the IRS to negotiate the
                                best possible outcome, including reduced
                                penalties or installment plans.
                            </li>
                            <li>
                                Appeals and Resolution: If the audit results in
                                an unfavorable decision, we can assist in filing
                                an appeal and guide you through the process of
                                challenging the IRS's findings.
                            </li>
                        </ul>
                    </div>
                    <img src={Image1} alt="user" />
                </div>
            </div>
        </Layout>
    );
}

export default About;
